import React from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { BiLoaderCircle } from 'react-icons/bi'
import { useGetPlayerCoinHistoryBlueday } from '../../../../../Hooks/Users/useGetPlayerCoinHistoryBlueday'

interface Props {
    show: boolean
    onHide: () => void
    form: {
        name: string
    }
}

export const PlayerCoinHistoryBluedayModal = ({ show, onHide, form }: Props) => {
    const { playerCoinHistory, loading } = useGetPlayerCoinHistoryBlueday({ form })


    const getHistoryColor = (e: any) => {
        if (e[3] === 'Bonificacion') { return 'orange' }
        if (parseFloat(e[4]?.replace(",", ".")) < 0) return 'red'
        if (parseFloat(e[4]?.replace(",", ".")) > 0) return 'green'
    }


    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Historial de cargas/retiros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!loading &&
                    <div className="text-primary d-flex justify-content-between mb-3">
                        El usuario {form.name} tiene {playerCoinHistory?.data?.TotalAmount} fichas.
                    </div>
                }
                <div className='d-flex justify-content-center'>

                    {loading && <div className='d-flex justify-content-center my-5 gap-2 align-items-center'>
                        <div className='spin-animation d-flex align-items-center justify-content-center'>
                            <BiLoaderCircle size={20} />
                        </div>
                        <span>Cargando...</span>
                    </div>}


                    {!loading &&
                        <div>
                            {playerCoinHistory?.data?.data?.map((item: any) => (
                                <div key={item.id}>
                                    <span style={{ color: getHistoryColor(item) }}>[{item[0]}] {item[4]} <span style={{ color: 'gray' }}>( {item[3]} )</span></span><br />
                                </div>



                            ))}
                        </div>}

                </div>
            </Modal.Body>
            <Modal.Footer>

                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>)
}
